import React from 'react';
import { Link } from 'react-router-dom';

const Itemnews = (props) => {
    return (
        <Link
            className="item-news"
            to={`/news/inner-page/${props.id}`} >
            <div className="pic">
                <img src={props.image} />
            </div>
            <h4>{props.title}</h4>
            <div className="tags-list tags all-styless">
                {props.tags.length == 0 ? null :
                    props.tags.map(info =>
                        <span>{info.name}</span>
                    )
                }
            </div>
            <div className="row-detailes">
                <span>{props.string_date}</span>
                <div className="view">
                    {/* {props.comment_count == undefined ? null :
                        <span>{props.comment_count}<i className="icon-view"></i></span>
                    } */}
                    {props.comment_count.length == 0 ? null :
                        <span>{props.comment_count}<i className="icon-comment"></i></span>
                    }
                </div>
            </div>
        </Link>
    );
}

export default Itemnews;